import React from 'react';
import { ArrowLeftIcon, CheckIcon } from 'lucide-react';
import { DS } from '../ds';
import { AlinovaConstellation } from '../Visuals';
import { Label, P } from '../Primitives';
const values = [{
  label: 'Innovación constante en tecnología dental'
}, {
  label: 'Compromiso con la calidad en cada alineador'
}, {
  label: 'Orientación total al profesional de salud'
}, {
  label: 'Confianza y transparencia en cada proceso'
}];
const LAB_IMAGE = 'https://cdn.magicpatterns.com/uploads/u94ZGmanr4Te82az7eNXJt/nosotros1.png';
const TEAM_IMAGE = 'https://cdn.magicpatterns.com/uploads/cX14cZf6SUKydCGy4ANwzs/equipo.png';
const CONSULT_IMAGE = 'https://cdn.magicpatterns.com/uploads/uLRr5MwvTHWLNR61iC9MXi/Consulta_moderna_de_ortodoncia.png';
interface AboutSectionProps {
  onBack: () => void;
}
export function AboutSection({
  onBack
}: AboutSectionProps) {
  return <div id="nosotros" style={{
    minHeight: '100vh',
    background: DS.color.ivory,
    paddingTop: '68px'
  }} data-id="element-123" data-mp="1e6blxzusutps">
      {/* Hero — fondo claro */}
      <section aria-labelledby="about-title" style={{
      background: `linear-gradient(160deg, #FDFAF5 0%, #F5F0E8 50%, #EEF7F7 100%)`,
      padding: '64px 24px 80px',
      position: 'relative',
      overflow: 'hidden',
      borderBottom: `1px solid ${DS.color.border}`
    }} data-id="element-124" data-mp="1dkb149n6garw">
        {/* Grid CAD sutil */}
        <div aria-hidden="true" style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: 'linear-gradient(rgba(26,95,115,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(26,95,115,0.03) 1px, transparent 1px)',
        backgroundSize: '52px 52px',
        pointerEvents: 'none'
      }} data-id="element-125" data-mp="1x93bm1ia975y" />

        <AlinovaConstellation width={360} height={360} opacity={0.05} rotation="counter" style={{
        position: 'absolute',
        top: '-80px',
        right: '-60px',
        pointerEvents: 'none'
      }} data-id="element-126" data-mp="2g1xrqyrn75br" />

        <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
      }} data-id="element-127" data-mp="deh3hothsg3i">
          {/* Botón volver */}
          <button type="button" onClick={onBack} style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          background: DS.color.mint,
          border: `1.5px solid ${DS.color.aqua}60`,
          borderRadius: DS.radius.pill,
          padding: '8px 18px',
          color: DS.color.tealDeep,
          fontFamily: DS.font.body,
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
          marginBottom: '40px',
          transition: `all 0.2s ${DS.ease.smooth}`,
          boxShadow: '0 2px 8px rgba(11,31,36,0.06)'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = DS.color.teal;
          e.currentTarget.style.borderColor = DS.color.teal;
          e.currentTarget.style.color = '#fff';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = DS.color.mint;
          e.currentTarget.style.borderColor = `${DS.color.aqua}60`;
          e.currentTarget.style.color = DS.color.tealDeep;
        }} data-id="element-128" data-mp="3lspmq6a4juj0">
            <ArrowLeftIcon size={14} aria-hidden="true" data-id="element-129" data-mp="2hvdrxpn8pnfc" />
            Volver al inicio
          </button>

          <Label data-id="element-130" data-mp="2dsh5toyhr96n">Nosotros</Label>
          <h1 id="about-title" style={{
          fontFamily: DS.font.heading,
          fontWeight: 700,
          fontSize: 'clamp(2rem, 5vw, 3.2rem)',
          background: `linear-gradient(135deg, ${DS.color.aqua}, ${DS.color.teal})`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          lineHeight: 1.1,
          letterSpacing: '-0.025em',
          margin: '12px 0 24px'
        }} data-id="element-131" data-mp="nhw19trjgag3">
            Tecnología dental hecha con propósito.
          </h1>
          <P size="lg" align="center" maxWidth="580px" data-id="element-132" data-mp="2817u8hudvrk">
            Somos el aliado tecnológico para odontólogos y ortodoncistas que
            quieren ofrecer ortodoncia invisible con precisión, respaldo clínico
            y una presentación que diferencia su clínica.
          </P>
        </div>
      </section>

      {/* Contenido principal */}
      <section style={{
      maxWidth: '1100px',
      margin: '0 auto',
      padding: '72px 24px 96px'
    }} data-id="element-133" data-mp="g0pt7gpmxrb2">
        {/* Bloque 1 — quiénes somos + imagen laboratorio */}
        <div className="col-2" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '56px',
        alignItems: 'center',
        marginBottom: '80px'
      }} data-id="element-134" data-mp="3jldeg64ocbrd">
          <div data-id="element-135" data-mp="324zsn4s4jvyp">
            <div style={eyebrowStyle} data-id="element-136" data-mp="324g8riiwyxi1">¿Por qué Alinova?</div>
            <h2 style={{
            fontFamily: DS.font.heading,
            fontWeight: 700,
            fontSize: 'clamp(1.5rem, 3vw, 2rem)',
            background: `linear-gradient(135deg, ${DS.color.aqua}, ${DS.color.teal})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            lineHeight: 1.2,
            letterSpacing: '-0.02em',
            marginBottom: '20px'
          }} data-id="element-137" data-mp="2y4z1cjjxfqa8">
              Fabricamos para que tú te enfoques en lo que más importa.
            </h2>
            <p style={bodyCopyStyle} data-id="element-138" data-mp="25h37dmlqsch5">
              En Alinova nos dedicamos al diseño y fabricación de alineadores
              invisibles que combinan tecnología de vanguardia, estética y
              comodidad. Permitimos a los odontólogos ofrecer tratamientos
              efectivos y discretos sin depender de infraestructura técnica propia.
            </p>

            <p style={{
            ...bodyCopyStyle,
            marginTop: '16px',
            fontStyle: 'italic',
            borderLeft: `3px solid ${DS.color.aqua}`,
            paddingLeft: '18px',
            color: DS.color.tealDeep
          }} data-id="element-139" data-mp="1qsjpoe7lslad">
              "Precios accesibles, alineadores de máxima calidad y cuidado
              en cada detalle — porque hacer difícil lo fácil no tiene sentido."
            </p>

            <div style={{
            marginTop: '28px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
          }} data-id="element-140" data-mp="2xhryfj97punr">
              {values.map(v => <div key={v.label} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }} data-id="element-141" data-mp="qryao2mws3r6">
                  <span style={{
                width: '22px',
                height: '22px',
                borderRadius: '50%',
                background: DS.color.mint,
                border: `1px solid ${DS.color.aqua}40`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }} data-id="element-142" data-mp="zlbfo2y8yvtm">
                    <CheckIcon size={12} color={DS.color.teal} strokeWidth={3} data-id="element-143" data-mp="bvyx4ch15ben" />
                  </span>
                  <span style={{
                fontFamily: DS.font.body,
                fontSize: '14px',
                color: DS.color.body
              }} data-id="element-144" data-mp="1s9ysrb8ueew3">
                    {v.label}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Imagen 1 — laboratorio dental con impresión 3D */}
          <div style={{
          borderRadius: DS.radius.cardLg,
          overflow: 'hidden',
          boxShadow: '0 24px 80px rgba(11,31,36,0.12)',
          aspectRatio: '4/5',
          position: 'relative',
          background: DS.color.linen
        }} data-id="element-145" data-mp="2gdon8zuvqi1r">
            <img src={LAB_IMAGE} alt="Laboratorio dental Alinova con tecnología de impresión 3D" style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            transition: `transform 0.6s ${DS.ease.smooth}`
          }} onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.04)'} onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} data-id="element-146" data-mp="2v1rro4t9xlog" />
            <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            padding: '10px 16px',
            borderRadius: '12px',
            background: 'rgba(11,31,36,0.72)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            border: '1px solid rgba(75,199,210,0.2)'
          }} data-id="element-147" data-mp="xeh1asrzlf6q">
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '11px',
              fontWeight: 700,
              color: DS.color.aquaLight,
              letterSpacing: '0.08em',
              textTransform: 'uppercase'
            }} data-id="element-148" data-mp="1c3wo5xoed0h5">
                Tecnología de precisión
              </div>
            </div>
          </div>
        </div>

        {/* Divisor */}
        <div style={{
        height: '1px',
        background: `linear-gradient(90deg, transparent, ${DS.color.aqua}40, transparent)`,
        marginBottom: '80px'
      }} data-id="element-149" data-mp="k5ctio22lqto" />

        {/* Bloque 2 — Misión + imagen equipo (orden invertido) */}
        <div className="col-2" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '56px',
        alignItems: 'center',
        marginBottom: '80px'
      }} data-id="element-150" data-mp="o5wqnrmn8uft">
          {/* Imagen 2 — equipo de especialistas */}
          <div style={{
          borderRadius: DS.radius.cardLg,
          overflow: 'hidden',
          boxShadow: '0 24px 80px rgba(11,31,36,0.12)',
          aspectRatio: '4/5',
          position: 'relative',
          background: DS.color.linen
        }} data-id="element-151" data-mp="1buzjlvmqa9pm">
            <img src={TEAM_IMAGE} alt="Equipo de especialistas Alinova en clínica dental" style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            transition: `transform 0.6s ${DS.ease.smooth}`
          }} onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.04)'} onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} data-id="element-152" data-mp="39nvcbmqf4gxe" />
            <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            padding: '10px 16px',
            borderRadius: '12px',
            background: 'rgba(11,31,36,0.72)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            border: '1px solid rgba(75,199,210,0.2)'
          }} data-id="element-153" data-mp="2kuithapqoczu">
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '11px',
              fontWeight: 700,
              color: DS.color.aquaLight,
              letterSpacing: '0.08em',
              textTransform: 'uppercase'
            }} data-id="element-154" data-mp="7n12ttmtan0r">
                Equipo Alinova
              </div>
            </div>
          </div>

          {/* Texto misión */}
          <div data-id="element-155" data-mp="r9p7gy0gkabw">
            <div style={eyebrowStyle} data-id="element-156" data-mp="rcbf0xncmpu4">Misión</div>
            <h2 style={{
            fontFamily: DS.font.heading,
            fontWeight: 700,
            fontSize: 'clamp(1.5rem, 3vw, 2rem)',
            background: `linear-gradient(135deg, ${DS.color.aqua}, ${DS.color.teal})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            lineHeight: 1.2,
            letterSpacing: '-0.02em',
            marginBottom: '20px'
          }} data-id="element-157" data-mp="mcgoiv7hk29l">
              Transformar la ortodoncia para profesionales colombianos.
            </h2>
            <p style={bodyCopyStyle} data-id="element-158" data-mp="1hkra8mry3w97">
              Ofrecemos alineadores de calidad superior adaptados a las
              necesidades de los pacientes y los estándares de los
              profesionales. Herramientas personalizadas, soporte técnico
              y materiales de alta tecnología para tratamientos efectivos,
              cómodos y discretos.
            </p>

            {/* Stats */}
            <div style={{
            marginTop: '32px',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '16px'
          }} data-id="element-159" data-mp="20had4uc5onxb">
              {[{
              value: '+50',
              label: 'Casos entregados'
            }, {
              value: '24h',
              label: 'Tiempo de respuesta'
            }, {
              value: '100%',
              label: 'Material certificado'
            }, {
              value: 'INVIMA',
              label: 'Certificación vigente'
            }].map(stat => <div key={stat.label} style={{
              padding: '16px 20px',
              borderRadius: '14px',
              background: DS.color.white,
              border: `1px solid ${DS.color.border}`,
              boxShadow: DS.shadow.card
            }} data-id="element-160" data-mp="3bzo7bcamxwx3">
                  <div style={{
                fontFamily: DS.font.heading,
                fontWeight: 700,
                fontSize: '1.6rem',
                color: DS.color.tealDeep,
                marginBottom: '2px'
              }} data-id="element-161" data-mp="2y059bcbjg1yi">
                    {stat.value}
                  </div>
                  <div style={{
                fontFamily: DS.font.body,
                fontSize: '12px',
                color: DS.color.muted
              }} data-id="element-162" data-mp="m9axy3mhvc5f">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Divisor */}
        <div style={{
        height: '1px',
        background: `linear-gradient(90deg, transparent, ${DS.color.aqua}40, transparent)`,
        marginBottom: '80px'
      }} data-id="element-163" data-mp="fv43mt439v6f" />

        {/* Bloque 3 — Visión + imagen consulta */}
        <div className="col-2" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '56px',
        alignItems: 'center',
        marginBottom: '80px'
      }} data-id="element-164" data-mp="1dhunfbynrxt4">
          <div data-id="element-165" data-mp="13qq8gc8zgcya">
            <div style={{
            ...eyebrowStyle,
            color: DS.color.kraft
          }} data-id="element-166" data-mp="13q6ut7qd8aq2">Visión</div>
            <h2 style={{
            fontFamily: DS.font.heading,
            fontWeight: 700,
            fontSize: 'clamp(1.5rem, 3vw, 2rem)',
            background: `linear-gradient(135deg, ${DS.color.aqua}, ${DS.color.teal})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            lineHeight: 1.2,
            letterSpacing: '-0.02em',
            marginBottom: '20px'
          }} data-id="element-167" data-mp="1rgu49xfxj8eq">
              Liderar el futuro de la ortodoncia invisible en Colombia.
            </h2>
            <p style={bodyCopyStyle} data-id="element-168" data-mp="1n79q3d36yx1n">
              Aspiramos a ser la marca de referencia reconocida por innovación
              constante, personalización de cada tratamiento y una experiencia
              que hace accesible, cómoda y estéticamente impecable la
              transformación de cada sonrisa.
            </p>

            {/* Quote */}
            <div style={{
            marginTop: '28px',
            padding: '20px 24px',
            borderRadius: '16px',
            background: DS.color.white,
            border: `1px solid ${DS.color.border}`,
            borderLeft: `4px solid ${DS.color.kraft}`,
            boxShadow: DS.shadow.card
          }} data-id="element-169" data-mp="14dxfnoqqcuqk">
              <p style={{
              fontFamily: DS.font.body,
              fontSize: '14px',
              color: DS.color.body,
              lineHeight: 1.7,
              margin: 0,
              fontStyle: 'italic'
            }} data-id="element-170" data-mp="3k3nt9ab5tqjs">
                "Imaginamos un mundo donde la transformación de una sonrisa
                sea accesible, cómoda y estéticamente impecable, brindando
                a cada persona la confianza para mostrar su mejor versión."
              </p>
            </div>
          </div>

          {/* Imagen 3 — ortodoncista con paciente */}
          <div style={{
          borderRadius: DS.radius.cardLg,
          overflow: 'hidden',
          boxShadow: '0 24px 80px rgba(11,31,36,0.12)',
          aspectRatio: '4/3',
          position: 'relative',
          background: DS.color.linen
        }} data-id="element-171" data-mp="28o7is9q49utn">
            <img src={CONSULT_IMAGE} alt="Ortodoncista revisando alineadores invisibles con paciente" style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            transition: `transform 0.6s ${DS.ease.smooth}`
          }} onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.04)'} onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} data-id="element-172" data-mp="123j1s8h3elis" />
            <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            padding: '10px 16px',
            borderRadius: '12px',
            background: 'rgba(11,31,36,0.72)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            border: '1px solid rgba(75,199,210,0.2)'
          }} data-id="element-173" data-mp="1usg7zd814rv6">
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '11px',
              fontWeight: 700,
              color: DS.color.aquaLight,
              letterSpacing: '0.08em',
              textTransform: 'uppercase'
            }} data-id="element-174" data-mp="2eb3xt8766x4m">
                Experiencia clínica
              </div>
            </div>
          </div>
        </div>

        {/* Banner INVIMA — claro y llamativo */}
        <div style={{
        borderRadius: '24px',
        overflow: 'hidden',
        boxShadow: `0 8px 40px rgba(75,199,210,0.14)`,
        border: `2px solid ${DS.color.aqua}50`
      }} data-id="element-175" data-mp="1zm7tnm88i49a">
          {/* Franja animada */}
          <div style={{
          height: '4px',
          background: `linear-gradient(90deg, ${DS.color.teal}, ${DS.color.aqua}, ${DS.color.teal})`,
          backgroundSize: '200% 100%',
          animation: 'shimmerBar 3s linear infinite'
        }} data-id="element-176" data-mp="1qo4agwkq1jkn" />

          <div style={{
          padding: '32px 40px',
          background: DS.color.white,
          display: 'flex',
          alignItems: 'center',
          gap: '24px',
          flexWrap: 'wrap'
        }} data-id="element-177" data-mp="1krt4swhwce2j">
            {/* Escudo */}
            <div style={{
            width: '52px',
            height: '52px',
            flexShrink: 0,
            borderRadius: '14px',
            background: `linear-gradient(135deg, ${DS.color.mint}, #E0F5F5)`,
            border: `2px solid ${DS.color.aqua}50`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: `0 4px 16px rgba(75,199,210,0.18)`
          }} data-id="element-178" data-mp="2cktiu7ah13me">
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" data-id="element-179" data-mp="31kg3jkbb8dhy">
                <path d="M13 2l4.5 2V10c0 4-2.5 6.5-4.5 7.5C11 16.5 8.5 14 8.5 10V4L13 2z" fill={`${DS.color.teal}15`} stroke={DS.color.teal} strokeWidth="1.5" strokeLinejoin="round" data-id="element-180" data-mp="31idh1a9d92hz" />
                <path d="M10 10.5l2.5 2.5 4-4" stroke={DS.color.tealDeep} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-181" data-mp="2mp08bbyzubjz" />
              </svg>
            </div>

            <div style={{
            flex: 1,
            minWidth: '200px'
          }} data-id="element-182" data-mp="2rkfl00l9m1et">
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '11px',
              fontWeight: 700,
              color: DS.color.teal,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              marginBottom: '5px'
            }} data-id="element-183" data-mp="bucrylegh46j">
                Laboratorio certificado · INVIMA
              </div>
              <div style={{
              fontFamily: DS.font.heading,
              fontWeight: 700,
              fontSize: '17px',
              color: DS.color.ink,
              marginBottom: '3px'
            }} data-id="element-184" data-mp="nygsjmqmkege">
                ADL Importaciones S.A.S
              </div>
              <div style={{
              fontFamily: DS.font.body,
              fontSize: '13px',
              color: DS.color.muted
            }} data-id="element-185" data-mp="58e3z5gukpr">
                Propietario del establecimiento{' '}
                <span style={{
                color: DS.color.teal,
                fontWeight: 600
              }} data-id="element-186" data-mp="38mcvo61uypu8">
                  Labtek Soluciones Dentales 3D
                </span>
              </div>
            </div>

            <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 20px',
            borderRadius: DS.radius.pill,
            background: `linear-gradient(135deg, ${DS.color.mint}, #E0F5F5)`,
            border: `1.5px solid ${DS.color.aqua}60`,
            fontFamily: DS.font.body,
            fontSize: '13px',
            fontWeight: 700,
            color: DS.color.tealDeep,
            whiteSpace: 'nowrap',
            boxShadow: `0 4px 12px rgba(75,199,210,0.15)`
          }} data-id="element-187" data-mp="36387gg57ga1q">
              <span style={{
              width: '7px',
              height: '7px',
              borderRadius: '50%',
              background: DS.color.teal,
              display: 'block',
              flexShrink: 0,
              animation: 'waPulse 2.5s ease-out infinite'
            }} data-id="element-188" data-mp="2dc6os52azwdg" />
              Certificación INVIMA vigente
            </div>
          </div>
        </div>

        {/* Keyframe */}
        <style data-id="element-189" data-mp="2t3qwyaky9pk8">{`
          @keyframes shimmerBar {
            0%   { background-position: 0% 50%; }
            100% { background-position: 200% 50%; }
          }
        `}</style>
      </section>
    </div>;
}
const eyebrowStyle: React.CSSProperties = {
  fontFamily: DS.font.body,
  fontSize: '11px',
  fontWeight: 700,
  color: DS.color.teal,
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  marginBottom: '14px'
};
const bodyCopyStyle: React.CSSProperties = {
  fontFamily: DS.font.body,
  fontSize: '15px',
  color: DS.color.body,
  lineHeight: 1.8,
  margin: 0
};